import { IconDotsVertical } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';

const ReferredBarChart = ({ userId, organizationId }) => {

    const [series, setSeries] = useState([{
        data: [0, 0, 0, 0, 0, 0, 0]

    }]);

    const [options, setOptions] = useState({
        chart: {
            height: 350,
            type: 'area',
            toolbar: {
                show: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 30,
                borderRadiusApplication: 'top',
                borderRadiusWhenStacked: 'last',
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        }, fill: {
            // type: "gradient",
            // gradient: {
            //     shadeIntensity: 1,
            //     opacityFrom: 1,
            //     opacityTo: 0,
            //     gradientToColors: ["white"],
            //     stops: [0, 100]
            // }
        },
        xaxis: {
            categories: [],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        tooltip: {
            x: {
                format: 'dd/MM/yy'
            }, y: {
                formatter: undefined,
                title: {
                    formatter: (seriesName) => 'Total',
                },
            },
        },
        grid: {
            strokeDashArray: 6,
            column: {
                colors: undefined,
                opacity: 0.1
            },
        }
    })

    async function getGraphData() {
        let tempArr = [];
        let tempArrX = [];
        let resp = await getApi(urlApi.userClickReferredData + userId + "/" + organizationId);
        if (resp.responseCode === 200) {
            for (const item of resp.data) {
                tempArr.push(item?.count ?? 0);
                tempArrX.push(item?.name ?? "Unknown");
            }
            setSeries([{
                data: tempArr
            }]);
            setOptions({ ...options, xaxis: { ...options.xaxis, categories: tempArrX } });
        }
    }

    useEffect(() => {
        getGraphData();

        return () => {

        }
    }, [userId, organizationId])

    return (
        <div className='bg-white p-1.5 rounded-xl h-max'>
            <div className="flex justify-between items-center p-1 gap-2">
                <div>
                    <p className='mb-0 text-md font-bold text-[var(--grey)]'>{`Clicks + scans by referrer`} </p>
                </div>
                <div className='flex ms-auto gap-2'>
                    {/* <button> <IconDotsVertical /> </button> */}
                </div>
            </div>
            <Chart options={options} series={series} height={'400px'} type="bar" />
        </div>
    )
}

export default ReferredBarChart